module.exports = __webpack_public_path__ + "img/Rectangle 9945.a7fc1180.svg";